import React from 'react';
import { useDashboardData } from './Dashboard';
import InfoTooltip from './InfoTooltip';

const DeliveryStatus = () => {
  const { deliveries: data } = useDashboardData();

  return (
    <div className="detail-panel">
      <div className="detail-panel-header">
        <div className="detail-panel-title">
          <i className="fas fa-truck me-2" style={{ color: '#3b82f6' }}></i>
          Teslimat Durumu
          <InfoTooltip text="Mevcut ve yaklaşan dönemin operasyonel yükü. Başarı oranı = Teslim Edilen / (Teslim + İade + İptal) × 100." />
        </div>
        {data?.deliverySuccessRate !== undefined && (
          <span className={`badge ${data.deliverySuccessRate >= 90 ? 'bg-success' : data.deliverySuccessRate >= 70 ? 'bg-warning text-dark' : 'bg-danger'}`}>
            %{data.deliverySuccessRate} Başarı
          </span>
        )}
      </div>
      <div className="detail-panel-body">
        {!data ? (
          <div className="section-loading"><div className="spinner-border spinner-border-sm" role="status"></div></div>
        ) : (
          <>
            {/* Pipeline Snapshot */}
            <div className="delivery-pipeline mb-3">
              <div className="small fw-semibold text-muted mb-2">Mevcut Süreç</div>
              <div className="d-flex gap-2 flex-wrap">
                <span className="badge bg-light text-dark border px-3 py-2">
                  <i className="fas fa-clock me-1 text-warning"></i> {data.pending} Bekleyen
                </span>
                <span className="badge bg-light text-dark border px-3 py-2">
                  <i className="fas fa-cog me-1 text-info"></i> {data.processing} İşleniyor
                </span>
                <span className="badge bg-light text-dark border px-3 py-2">
                  <i className="fas fa-truck me-1 text-primary"></i> {data.shipped} Kargoda
                </span>
              </div>
            </div>

            {/* Actionable Stats */}
            <div className="mini-stats-grid">
              <div className="mini-stat">
                <div className="mini-stat-value">{data.tomorrowScheduled}</div>
                <div className="mini-stat-label">Yarın Hazırlanacak</div>
              </div>
              <div className="mini-stat">
                <div className="mini-stat-value">{data.nextWeekScheduled}</div>
                <div className="mini-stat-label">Haftaya Hazırlanacak</div>
              </div>
              <div className="mini-stat">
                <div className="mini-stat-value">{data.thisWeekShipped}</div>
                <div className="mini-stat-label">Depodan Çıkan (Bu Hafta)</div>
              </div>
              <div className="mini-stat">
                <div className="mini-stat-value" style={{ color: data.attentionRequired > 0 ? '#ef4444' : 'inherit' }}>
                  {data.attentionRequired}
                </div>
                <div className="mini-stat-label">Gecikmiş İşlem</div>
              </div>
            </div>

            {/* This Month Summary */}
            {data.doughnut && (
              <div className="mt-3 pt-3 border-top">
                <div className="small fw-semibold text-muted mb-2">{data.doughnut.period} Özeti</div>
                <div className="d-flex gap-3 flex-wrap small">
                  <span><i className="fas fa-circle me-1" style={{ color: '#10b981', fontSize: '0.5rem', verticalAlign: 'middle' }}></i> {data.doughnut.delivered} Teslim</span>
                  <span><i className="fas fa-circle me-1" style={{ color: '#3b82f6', fontSize: '0.5rem', verticalAlign: 'middle' }}></i> {data.doughnut.shipped} Kargo</span>
                  <span><i className="fas fa-circle me-1" style={{ color: '#ef4444', fontSize: '0.5rem', verticalAlign: 'middle' }}></i> {data.doughnut.returned} İade</span>
                  <span><i className="fas fa-circle me-1" style={{ color: '#9ca3af', fontSize: '0.5rem', verticalAlign: 'middle' }}></i> {data.doughnut.cancelled} İptal</span>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default DeliveryStatus;
